var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isAuthenticated
      ? _c(
          "div",
          [
            _c("AppHeader"),
            _c(
              "section",
              { staticClass: "forgot-password-sc navbar-space no-padding" },
              [
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "row justify-content-center" }, [
                    _c(
                      "div",
                      { staticClass: "col-lg-8 col-sm-12 col-xl-7 col-xs-fix" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "personal-info-wrapper mb-5",
                            attrs: { id: "accordion" }
                          },
                          [
                            _c(
                              "form",
                              {
                                on: {
                                  submit: function($event) {
                                    $event.preventDefault()
                                    return _vm.changePassword($event)
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "card card-form" }, [
                                  _vm._m(0),
                                  _c(
                                    "div",
                                    {
                                      attrs: {
                                        id: "collapseTwo",
                                        "aria-labelledby": "headingTwo",
                                        "data-parent": "#accordion"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "card-body compact-padding"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "default-padding" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "form-group mb-2"
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v("ตั้งรหัสผ่านใหม่")
                                                  ]),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "pass-form-wrapper"
                                                    },
                                                    [
                                                      _c("vue-password", {
                                                        directives: [
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {
                                                              required: true,
                                                              min: 8,
                                                              max: 20
                                                            },
                                                            expression:
                                                              "{ required:true,min:8,max:20}"
                                                          }
                                                        ],
                                                        class: {
                                                          input: true,
                                                          "is-danger": _vm.errors.has(
                                                            "oldpassword"
                                                          )
                                                        },
                                                        attrs: {
                                                          name: "oldpassword",
                                                          classes:
                                                            "form-control",
                                                          "data-vv-as":
                                                            "รหัสผ่านเดิม",
                                                          placeholder:
                                                            "รหัสผ่านเดิม",
                                                          disableStrength: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.oldpassword,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.oldpassword = $$v
                                                          },
                                                          expression:
                                                            "oldpassword"
                                                        }
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value: _vm.errors.has(
                                                                "oldpassword"
                                                              ),
                                                              expression:
                                                                "errors.has('oldpassword')"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "help is-danger"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "oldpassword"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "form-group mb-4"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "pass-form-wrapper"
                                                    },
                                                    [
                                                      _c("vue-password", {
                                                        directives: [
                                                          {
                                                            name: "validate",
                                                            rawName:
                                                              "v-validate",
                                                            value: {
                                                              required: true,
                                                              min: 8,
                                                              max: 20,
                                                              regex: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])([a-zA-Z0-9]{8,20})$/
                                                            },
                                                            expression:
                                                              "{ required:true,min:8,max:20, regex:/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])([a-zA-Z0-9]{8,20})$/,}"
                                                          }
                                                        ],
                                                        class: {
                                                          input: true,
                                                          "is-danger": _vm.errors.has(
                                                            "password"
                                                          )
                                                        },
                                                        attrs: {
                                                          name: "password",
                                                          classes:
                                                            "form-control",
                                                          "data-vv-as":
                                                            "รหัสผ่านใหม่",
                                                          placeholder:
                                                            "รหัสผ่านใหม่",
                                                          disableStrength: ""
                                                        },
                                                        model: {
                                                          value: _vm.password,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.password = $$v
                                                          },
                                                          expression: "password"
                                                        }
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value: _vm.errors.has(
                                                                "password"
                                                              ),
                                                              expression:
                                                                "errors.has('password')"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "help is-danger"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.errors.first(
                                                                "password"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "pass-form-wrapper"
                                                        },
                                                        [
                                                          _c("vue-password", {
                                                            directives: [
                                                              {
                                                                name:
                                                                  "validate",
                                                                rawName:
                                                                  "v-validate",
                                                                value: {
                                                                  required: true,
                                                                  confirmed:
                                                                    _vm.password
                                                                },
                                                                expression:
                                                                  "{ required:true,confirmed:password}"
                                                              }
                                                            ],
                                                            class: {
                                                              input: true,
                                                              "is-danger": _vm.errors.has(
                                                                "confirmpassword"
                                                              )
                                                            },
                                                            attrs: {
                                                              name:
                                                                "confirmpassword",
                                                              classes:
                                                                "form-control",
                                                              placeholder:
                                                                "ยืนยันรหัสผ่าน",
                                                              "data-vv-as":
                                                                "ยืนยันรหัสผ่าน",
                                                              disableStrength:
                                                                ""
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.confirmpassword,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.confirmpassword = $$v
                                                              },
                                                              expression:
                                                                "confirmpassword"
                                                            }
                                                          }),
                                                          _c(
                                                            "span",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value: _vm.errors.has(
                                                                    "confirmpassword"
                                                                  ),
                                                                  expression:
                                                                    "errors.has('confirmpassword')"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "help is-danger"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.errors.first(
                                                                    "confirmpassword"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              ),
                                              _vm._m(1),
                                              _vm._m(2),
                                              _vm._m(3)
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ])
              ]
            ),
            _c("AppFooter")
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card-header",
        attrs: {
          id: "headingTwo",
          "data-toggle": "collapse",
          "data-target": "#collapseTwo",
          "aria-expanded": "true",
          "aria-controls": "collapseTwo"
        }
      },
      [
        _c("div", { staticClass: "title" }, [
          _c("i", { staticClass: "feather-icon icon-lock" }),
          _c("h5", { staticClass: "mb-0" }, [_vm._v("ตั้งรหัสผ่านใหม่")])
        ]),
        _c("i", { staticClass: "feather-icon icon-chevron-left" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group mb-4" }, [
      _c("div", { staticClass: "form-text" }, [
        _c("li", [_vm._v('ความยาวของรหัสผ่านต้องไม่น้อยกว่า "8-20" ตัวอักษร')]),
        _c("li", [_vm._v("ตัวอักษรต้องประกอบด้วยตัวเล็กและตัวใหญ่")]),
        _c("li", [_vm._v('ต้องประกอบด้วยตัวเลขอย่างน้อย "1"')])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center mt-3" }, [
      _c("div", { staticClass: "col-sm-7 col-lg-7 col-xl-7" }, [
        _c("div", { staticClass: "cta-btn single-btn mb-0" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-info btn-round btn-block shadow-sm",
              attrs: { type: "submit" }
            },
            [_vm._v("ยืนยัน")]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center mt-3" }, [
      _c("div", { staticClass: "col-sm-7 col-lg-7 col-xl-7" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }